import * as React from 'react';
import styled from 'styled-components';

import { FONT_SIZE, SPACING } from '../../../../packages/constants';
import THEME from '../../../../packages/constants/themes';
import { DataGridModes } from '../../data-grid';
import { Button } from '../../../button';

const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: ${SPACING.X_SMALL};
    padding-bottom: ${SPACING.X_SMALL};
`;

const TopRowLeftButtonsWrapper = styled.div`
    display: flex;
    margin-right: auto;
`;

const TextAccounts = styled.p`
    align-self: center;
    font-size: ${FONT_SIZE.SMALL};
`;

const TextCurrency = styled.p`
    align-self: center;
    font-size: ${FONT_SIZE.X_SMALL};
`;

const EliminationsSaveButton = styled(Button)`
    margin: 0 0 0 10px;
    padding: 0 8px;
`;

const EliminationsCancelButton = styled(Button)`
    margin: 0 0 0 10px;
    padding: 0 8px;
`;

const EliminationsEditButton = styled(Button)`
    margin: 0 0 0 10px;
    padding: 0 8px;
`;

const AdjustArapButton = styled(Button)`
    margin: 0 auto 0 10px;
    padding: 0 8px;
`;

interface EliminationsControlsProps {
    dataId: string;
    mode: DataGridModes;
    editEliminationsHandler: () => void;
    saveEliminationsHandler: () => void;
    cancelEliminationsHandler: () => void;
}

export const EliminationsControls: React.FC<React.PropsWithChildren<EliminationsControlsProps>> = ({
    dataId,
    mode,
    editEliminationsHandler,
    saveEliminationsHandler,
    cancelEliminationsHandler,
}) => {
    if (mode === DataGridModes.EditEliminations) {
        return (
            <>
                <EliminationsSaveButton
                    dataId={`${dataId}__button-save-eliminations`}
                    onClick={saveEliminationsHandler}
                >
                    Save Eliminations
                </EliminationsSaveButton>
                <EliminationsCancelButton
                    dataId={`${dataId}__button-cancel-eliminations`}
                    theme={THEME.GENERIC}
                    onClick={cancelEliminationsHandler}
                >
                    Cancel
                </EliminationsCancelButton>
            </>
        );
    } else {
        return (
            <EliminationsEditButton dataId={`${dataId}__button-edit-eliminations`} onClick={editEliminationsHandler}>
                Edit Eliminations
            </EliminationsEditButton>
        );
    }
};

interface DataGridHeaderProps {
    dataId: string;
    mode: DataGridModes;
    numAccounts: number;
    currency: string;
    hasEliminationsMode: boolean;
    hasArapAdjustments: boolean;
    editEliminationsHandler: () => void;
    saveEliminationsHandler: () => Promise<void>;
    cancelEliminationsHandler: () => void;
    adjustArapHandler: () => void;
}

export const DataGridHeader: React.FC<React.PropsWithChildren<DataGridHeaderProps>> = ({
    dataId,
    mode,
    numAccounts,
    currency,
    hasEliminationsMode,
    hasArapAdjustments,
    editEliminationsHandler,
    saveEliminationsHandler,
    cancelEliminationsHandler,
    adjustArapHandler,
}) => {
    return (
        <TopRow data-test-id={`${dataId}__header`}>
            <TextAccounts>{numAccounts} Accounts</TextAccounts>
            <TopRowLeftButtonsWrapper>
                {hasEliminationsMode && (
                    <EliminationsControls
                        dataId={dataId}
                        mode={mode}
                        editEliminationsHandler={editEliminationsHandler}
                        saveEliminationsHandler={saveEliminationsHandler}
                        cancelEliminationsHandler={cancelEliminationsHandler}
                    />
                )}
                {hasArapAdjustments && mode != DataGridModes.EditEliminations && (
                    <AdjustArapButton
                        dataId={`${dataId}__button-adjust-ar-ap`}
                        theme={THEME.GENERIC}
                        onClick={adjustArapHandler}
                    >
                        Adjust AR &amp; AP
                    </AdjustArapButton>
                )}
            </TopRowLeftButtonsWrapper>
            <TextCurrency data-test-id={`${dataId}__p-currency-text-container`}>
                All values are in {currency}
            </TextCurrency>
        </TopRow>
    );
};
